import { start } from "@ausmahi/telemetry/client";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

// The browser entry (React Router's default, revealed so telemetry starts before hydration: the outbox from the last
// page flushes, and an error during hydration is on the page's record). root.tsx says ready() once hydrated.
start({ client: import.meta.env.VITE_COMMIT || undefined });

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
